export default "__VITE_ASSET__DAp$HKOJ__"